var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionHindi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#1A5C4B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.86 21.54L13.82 19.96C12.14 19.48 11.32 18.14 11.32 16V12.8H10V10.56H22.6V12.8H20.76V23H17.96V19.66L12.14 23.52L10.86 21.54ZM17.96 12.8H14.1V15.96C14.1 17.38 14.64 17.94 15.72 17.94C16.56 17.94 17.38 17.48 17.96 16.94V12.8Z",
    fill: "#DBEFBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionHindi);
export default __webpack_public_path__ + "static/media/QuestionHindi.15cd755af3880a7d81a9178998576ff8.svg";
export { ForwardRef as ReactComponent };